import auth from "@react-native-firebase/auth";
import clientStorage from "core/clientStorage";
import { fs, FULL_SCREEN, rgba, rh, rw } from "core/designHelpers";
import { getLocalStorageItem, setLocalStorageItem } from "core/helpers";
import navhelper from "core/navhelper";
import StyleSheetRW from "core/StyleSheetRW";
import { IsValidEmail, validateAll } from "core/validators";
import { useEffect, useState } from "react";
import { Dimensions, SafeAreaView, Text, View } from "react-native";
import env from "res/env";
import { redirectLoggedInUser } from "src/commons";
import AppButton from "src/components/AppButton";
import Dialog from "src/components/Dialog";
import Header from "src/components/Header";
import PasswordField from "src/components/PasswordField";
import TextField from "src/components/TextField";
export default function LoginScreen({ componentId }: any) {
  const [email, setEmail] = useState<string>(
    __DEV__ ? "dev0352@yopmail.com" : clientStorage.getItem("lastSuccessEmail")
  );
  const [showToast, setShowToast] = useState(false);



  const [password, setPassword] = useState<string>(__DEV__ ? "Say7names" : "");
  const [errors, setErrors] = useState<any>({});
  const screenWidth = Dimensions.get('window').width;

  const handleLogin = async () => {
    let rules = [
      { email, rule: IsValidEmail },
      //{ password, rule: IsValidPassword }
    ];
    if (env.type == "mock") rules.pop();
    let newErrors = validateAll(rules);
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    auth()
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if (user) {
          if (user.accessToken) {
            setLocalStorageItem("loggedinUser", userCredential.user)
            redirectLoggedInUser(user)
          } else {
            console.error("User access token is undefined");
          }
        } else {
          console.error("User is undefined");
        }
      })
      .catch((error) => {
        setErrors({ message: error.message || 'An error occurred during login' });
        setShowToast(true)
      });
  }
  return (
    <>
      <Dialog message="Email or password is incorrect" isDialogVisible={showToast} onDialogClose={() => setShowToast(false)} />
      <SafeAreaView style={[FULL_SCREEN, { width: screenWidth }]}>

        <Header
          title="Login"
          leftButton={{
            title: "Sign Up",
            onPress: () => { },
            opacity: 0.5,
            disable: true
          }}
          noBack={true}
          subHeadingtxt="Login"
          marginTop={10}
        />
        <View style={{ alignItems: "center" }}>
          <TextField
            label="Email address"
            value={email}
            placeholder="Email address"
            onChangeText={(newEmail) => setEmail(newEmail.trim())}
            errorMsg={errors["email"]}
            onSubmitEditing={handleLogin}
          />
          <View style={{ height: rh(20), }} />
          <PasswordField
            label="Password"
            value={password}
            placeholder="Password"
            onChangeText={(newPassword) => setPassword(newPassword)}
            errorMsg={errors["password"]}
            onSubmitEditing={handleLogin}
          />
          <Text
            style={styles.forgotPwdTxt}
            onPress={() => navhelper.push("ResetPasswordScreen")}
          >
            Forgot Password?
          </Text>
          <View style={{ height: rh(103) }} />
          <AppButton
            onPress={handleLogin}
            title="Login"
            enabled={env.type == "mock" || (!!email && !!password)}
            loaderDelayMillis={5000}
            allowEnterKey={true}
          /></View>
      </SafeAreaView>
    </>
  );
}

const styles = StyleSheetRW.create(() => ({
  header: {
    width: "100%",
    height: rh(41),
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: rh(31),
  },
  inputBox: {
    width: rw(343),
    backgroundColor: rgba(0, 0, 0, 0.05),
    height: rh(60),
    borderRadius: 10,
    fontFamily: "Outfit",
    fontSize: fs(16),
    fontWeight: "400",
    color: "#333333",
    paddingHorizontal: rw(16),
  },
  forgotPwdTxt: {
    fontFamily: "Outfit",
    fontSize: fs(16),
    marginHorizontal: rw(16),
    width: rw(343),
    textAlign: "center",
    fontWeight: "500",
    color: rgba(3, 149, 144, 1),
    marginTop: rh(30),
  },
  heading: { fontFamily: "Outfit", textAlign: "center", fontSize: fs(18), fontWeight: "600", color: "rgba(51, 51, 51, 1)", marginTop: rh(30), marginBottom: rh(50), },

}));
